import React from 'react'
import withRedux from 'next-redux-wrapper'
import { App, Store } from 'apps/public/whySell'
import { storeSetup } from 'lib/pageSetup'
import Theme from 'components/Theme'
const METADATA = {
  title: 'Why Sell | Saatchi Art',
  description: 'Supporting artists in over 100 counties as the world’s leading art gallery, find your success by selling your art on Saatchi Art.',
  robots: true,
}

// Sample App Default file Structure
function WhySell({
  layout,
}: Record<string, any>): React.ReactElement<React.ComponentProps<any>, any> {
  return (
    <Theme>
      <App layout={layout} />
    </Theme>
  )
}

WhySell.getInitialProps = async ({ store, req, query }): Record<string, any> => {
  // Client-Side
  if (!req) {
    return {
      metaData: METADATA,
    }
  }

  // SSR Logic
  storeSetup(store, req)
  // Metadata & Datalayer
  return {
    dataLayer: {},
    metaData: METADATA,
  }
}

export default withRedux(Store)(WhySell)
